// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".2f70bb3eb1a3aef8746f9f67f02ed033.js";
};